import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { useAuth } from "@/features/auth/store";
import { MoistureVerificationPage } from "@/features/quality/components/moisture/moisture-verification-page";

const search = z.object({
  tab: z.enum(["pending", "verified"]).default("pending"),
  srfNo: z.string().optional(),
  from: z.string().optional(),
  to: z.string().optional(),
  // The finished tab's page; the live tabs scroll.
  page: z.number().int().min(1).default(1).catch(1),
});

export const Route = createFileRoute("/_app/quality/moisture/")({
  validateSearch: search,
  beforeLoad: () => {
    if (!useAuth.getState().can("qc.verify")) throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const s = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <MoistureVerificationPage
      search={s}
      onSearch={(next) =>
        void navigate({ search: (prev) => ({ ...prev, ...next }) })
      }
    />
  );
}
